"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("../");

var _ButtonBase = _interopRequireDefault(require("@material-ui/core/ButtonBase"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ButtonBack = ({
  className,
  onClick
}) => {
  return _react.default.createElement(_ButtonBase.default, {
    className: className,
    onClick: onClick
  }, "Endre");
};

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "block",
    position: "relative"
  },
  header: {
    display: "flex",
    borderTop: "1px solid",
    borderColor: "#ccc",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: "18px"
  },
  title: {
    fontFamily: "Akkurat, sans-serif",
    fontWeight: "bold",
    lineHeight: "24px"
  },
  toggleButton: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "14px",
    fontWeight: "normal",
    margin: "0 6px"
  },
  section: {
    display: "block",
    width: "100%",
    padding: "18px 25px"
  }
}));

const AppsByUser = ({
  title,
  onCollapse,
  apps,
  onSelect
}) => {
  const classes = useStyles();
  return _react.default.createElement("section", {
    className: classes.root
  }, title && _react.default.createElement("header", {
    className: classes.header
  }, _react.default.createElement(_Typography.default, {
    className: classes.title
  }, title), _react.default.createElement(ButtonBack, {
    className: classes.toggleButton,
    onClick: onCollapse
  })), _react.default.createElement("div", {
    className: classes.section
  }, _react.default.createElement(_.AppsGrid, {
    apps: apps,
    onSelect: onSelect
  })));
};

var _default = AppsByUser;
exports.default = _default;
module.exports = exports.default;